module.exports = "/images/bg_everest33.jpg?884b99d048248b563f803544ed4c16ce";